/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: version
 * note:
 *  - versionファイル（ver.json）をダウンロードして、今のバージョンと異なる場合はリロードする
 *  - リロードすることで、新しいバージョンのファイル群を取得することを期待している
 * sample:
 *  -
 * :ZNOTE:
 */

import {getFetch} from './env';

const versionCheck = async (expectedVersion='') => {
  const fetch: any = getFetch();
  const timestamp = new Date().getTime();
  try {
    const response: any = await fetch(`/ver.json?ts=${timestamp}`, {method: 'GET'});
    const responseJson = await response.json();
    if (responseJson.version !== expectedVersion) {
      location.reload();
    }
  } catch (e) {}
};

export {versionCheck};
